// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__25xuP","large":"styles_large__cmh38"};